import axios from 'axios'
import React, { useState } from 'react'
import { Comment } from '../../../models/blog'
import { Button } from '@components/UI/Button'

interface Props {
  id: number
  comment: Comment
}
export default function AddComment(props: Props) {
  const { id } = props
  const [commentAuthor, setName] = useState('')
  const [commentAuthorEmail, setEmail] = useState('')
  const [commentAuthorUrl, setWebsite] = useState('')
  const [commentContent, setComment] = useState('')

  const handleCommentSubmit = (e: React.ChangeEvent<HTMLFormElement>): void => {
    e.preventDefault()
    if (
      !commentAuthor ||
      !commentAuthorEmail ||
      !commentAuthorUrl ||
      !commentContent
    ) {
      return
    }
    const data = {
      commentAuthor,
      commentAuthorEmail,
      commentAuthorUrl,
      commentContent,
      comment_post_ID: id
      // comment_parent: comment.comment_ID
    }
    const sendReqData: {} = {
      url: `${process.env.NEXT_PUBLIC_BLOG_URL}/wp-json/wpr/v1/add-comment-next`,
      data,
      method: 'POST'
    }
    void axios(sendReqData).then(resp => {
      if (resp.data) {
        alert('Comment Added To This Post')
      }
    })
  }

  return (
    <div>
      <form onSubmit={handleCommentSubmit}>
        <div className="mb-4 border">
          <textarea
            className="w-full py-2 px-4 focus:outline-none focus:ring focus:border-red"
            placeholder="Your Comment *"
            value={commentContent}
            required
            onChange={e => setComment(e.target.value)}
          />
        </div>
        <div className="mb-4 border ">
          <input
            type="text"
            className="w-full py-2 px-4 focus:outline-none focus:ring focus:border-red"
            placeholder="Enter Your Name *"
            value={commentAuthor}
            required
            onChange={e => setName(e.target.value)}
          />
        </div>

        <div className="mb-4 border">
          <input
            type="email"
            className="w-full py-2 px-4 focus:outline-none focus:ring focus:border-red"
            placeholder="Enter Your Email *"
            value={commentAuthorEmail}
            required
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-4 border">
          <input
            type="text"
            className="w-full py-2 px-4 focus:outline-none focus:ring focus:border-red"
            placeholder="Enter Your Website *"
            value={commentAuthorUrl}
            required
            onChange={e => setWebsite(e.target.value)}
          />
        </div>
        <Button type="submit" variant="dark" wide>
          Send A Comment
        </Button>
      </form>
    </div>
  )
}
